import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMotionTrafficReports } from "../../../store/slices/fault-module/motion-traffic-report.slice";
import MotionTrafficReportTableComponent from "./motion-traffic-report-table.component";

const MotionTrafficReportComponent = () => {
  const [selectedReportType, setSelectedReportType] = useState<number>();
  const [motionCountVsTimeData, setMotionCountVsTimeData] = useState<any>({});
  const [motionCountVsSensorData, setMotionCountVsSensorData] = useState<any>(
    {}
  );

  const [motionCountVsLevelData, setMotionCountVsLevelData] = useState<{
    seriesData: [];
    xAxisValues: [];
  }>({ seriesData: [], xAxisValues: [] });

  const [motionCountVsLocationData, setMotionCountVsLocationData] = useState<{
    seriesData: [];
    xAxisValues: [];
  }>({ seriesData: [], xAxisValues: [] });

  const dispatch = useDispatch();

  const motionTrafficReportData = useSelector((state: any) => {
    return state.motionTrafficReport.motionTrafficReports;
  });

  const isLoadingMotionTrafficReportData = useSelector((state: any) => {
    return state.motionTrafficReport.isLoading;
  });

  const getSelectedReportType = (reportType: number) => {
    setSelectedReportType(reportType);
  };

  useEffect(() => {
    if (motionTrafficReportData?.data) {
      // Motion vs Time
      if (selectedReportType == 1) {
        const reportTime = motionTrafficReportData?.data?.map(
          (d: any) => d?.hour
        );

        const countPerHr = motionTrafficReportData?.data?.every(
          (d: any) => d?.motionCount == null
        )
          ? null
          : motionTrafficReportData?.data?.map((d: any) => d?.motionCount);

        setMotionCountVsTimeData({
          reportTime,
          countPerHr,
        });
      } else if (
        selectedReportType == 2 &&
        motionTrafficReportData?.data?.length > 0
      ) {
        // Motion Count Vs Sensor
        // debugger;
        const sensorIds = motionTrafficReportData?.data?.map(
          (d: any) => d.sensorDisplayName
        );

        const yAxisMotionCount = motionTrafficReportData?.data?.map(
          (d: any) => d.motionCount
        );

        const extraData = motionTrafficReportData?.data?.map((d: any) => {
          return {
            code: d?.assetCode,
            displayName: d?.sensorDisplayName,
            location: d?.assetDisplayLocation,
            level: d?.location,
          };
        });

        setMotionCountVsSensorData({
          sensorIds,
          countPerNode: yAxisMotionCount,
          extraData,
        });
      } else if (selectedReportType == 3) {
        // Motion Count Vs Level
        const { assetDisplayLevels, assetDisplayLocationMotion } =
          motionTrafficReportData.data;

        const indicesToKeep = assetDisplayLevels?.map((_: any, index: any) =>
          assetDisplayLocationMotion.some(
            (locationMotion: any) => locationMotion.motionDatas[index] != null
          )
        );

        // Filter the assetDisplayLevels and motionDatas based on the indices to keep
        const filteredAssetDisplayLevels = assetDisplayLevels?.filter(
          (_: any, index: any) => indicesToKeep[index]
        );

        const filteredAssetDisplayLocationMotion =
          assetDisplayLocationMotion?.map((locationMotion: any) => ({
            ...locationMotion,
            motionDatas: locationMotion.motionDatas.filter(
              (_: any, index: any) => indicesToKeep[index]
            ),
          }));

        const xAxisValues = filteredAssetDisplayLevels;

        const seriesData = filteredAssetDisplayLocationMotion?.every(
          (d: any) => d?.secondaryLocation == null || d?.motionDatas == null
        )
          ? null
          : filteredAssetDisplayLocationMotion?.map((d: any) => ({
            name: d?.secondaryLocation,
            data: d?.motionDatas,
          }));

        setMotionCountVsLevelData({ seriesData, xAxisValues });
      } else if (selectedReportType == 4) {
        // Motion Count Vs Level
        const { assetDisplayLocations, assetDisplayLevelMotion } =
          motionTrafficReportData.data;

        const indicesToKeep = assetDisplayLocations?.map((_: any, index: any) =>
          assetDisplayLevelMotion.some(
            (locationMotion: any) => locationMotion.motionDatas[index] != null
          )
        );

        // Filter the assetDisplayLevels and motionDatas based on the indices to keep
        const filteredAssetDisplayLevels = assetDisplayLocations?.filter(
          (_: any, index: any) => indicesToKeep[index]
        );

        const filteredAssetDisplayLocationMotion = assetDisplayLevelMotion?.map(
          (locationMotion: any) => ({
            ...locationMotion,
            motionDatas: locationMotion.motionDatas?.filter(
              (_: any, index: any) => indicesToKeep[index]
            ),
          })
        );

        const xAxisValues = filteredAssetDisplayLevels;

        const seriesData = filteredAssetDisplayLocationMotion?.every(
          (d: any) => d?.secondaryLocation == null || d?.motionDatas == null
        )
          ? null
          : filteredAssetDisplayLocationMotion?.map((d: any) => ({
            name: d?.secondaryLocation,
            data: d?.motionDatas,
          }));

        setMotionCountVsLocationData({ seriesData, xAxisValues });
      }
    } else {
      setMotionCountVsSensorData({
        sensorIds: [],
        motionCount: [],
        extraData: [],
      });

      setMotionCountVsTimeData({
        reportTime: [],
        countPerHr: [],
      });

      setMotionCountVsLevelData({
        seriesData: [],
        xAxisValues: [],
      });

      setMotionCountVsLocationData({
        seriesData: [],
        xAxisValues: [],
      });
    }
  }, [motionTrafficReportData, selectedReportType]);

  const onRefetchData = (
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    timePeriod = null,
    asset = null
  ) => {
    dispatch(
      getMotionTrafficReports({
        tcCode,
        siteCode,
        blockCode,
        reportType,
        startDate,
        endDate,
        timePeriod,
        asset,
      })
    );
  };

  return (
    <div>
      <MotionTrafficReportTableComponent
        motionVsTimeData={motionCountVsTimeData}
        motionVsSensorData={motionCountVsSensorData}
        motionCountVsLevelData={motionCountVsLevelData}
        motionCountVsLocationData={motionCountVsLocationData}
        onRefetchData={onRefetchData}
        isLoading={isLoadingMotionTrafficReportData}
        getSelectedReportType={getSelectedReportType}
      />
    </div>
  );
};

export default MotionTrafficReportComponent;
